<!-- Need Individual-->
<ng-template #needed let-modal="let-modal" let-d="dismiss">
	<div class="modal-header">
		<h3 class="modal-title" id="modal-basic-title">How Many Leads Needed?</h3>
		<div class="modal-title" id="modal-basic-title" *ngIf="title_reserve != ''">
			{{ campaignUpdate.name }} - {{ campaignUpdate.leads_needed }}
			<div style="text-align: left; display: block">
				<p style="margin-top: 15px; font-weight: 600; font-size: 1em">
					{{ title_reserve }}
				</p>
				<div class="col-12" id="status_lead"></div>
				<ul class="list-group list-group-flush">
					<li class="list-group-item">
						{{ overview_leads }}
					</li>
				</ul>

				<p style="color: red; font-size: 0.75em">{{ text_leads_reserve }}</p>
				<!-- <a href="#" style="font-weight: 600; text-decoration: underline;">Click here to see leads</a> -->
			</div>
		</div>
	</div>
	<div class="modal-body">
		<form>
			<div class="form-group">
				<input [(ngModel)]="leads_needed" name="leads_needed" type="text" class="form-control" placeholder="Enter the new number of leads needed." (focus)="focus = true" />
			</div>
		</form>
	</div>
	<div class="modal-footer p-3">
		<button type="button" (click)="d()" class="btn btn-danger">Cancel</button>
		<button type="button" (click)="validateLeadsNeeded(); d()" class="btn btn-secondary">Save</button>
	</div>
</ng-template>
<!-- End Needed Individual-->
<!-- Needed Multiple -->
<ng-template #content role="document" let-modal>
	<div class="modal-header">
		<h3 class="modal-title" id="modal-basic-title">How Many Leads Needed?</h3>
		<button type="button" class="btn-close" aria-hidden="true" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<form>
			<div class="form-group">
				<input [(ngModel)]="multiple_leads_needed" name="multiple_leads_needed" type="text" class="form-control" placeholder="Enter the new number of leads needed." (focus)="focus = true" (change)="validateMultipleLeadsNeeded()" />
			</div>

			<div class="row mt-4">
				<div *ngFor="let active of activeCampaigns; let i = index" class="col-md-3 mb-2"><input id="checkbox_{{ active.id }}" type="checkbox" style="font-size: 11px" (change)="changeCampaignNeeded(active.id)" /> {{ active.name }}</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-danger" (click)="closeNeededModal(); modal.close('Close click')">Close</button>
		<!-- <button type="button" (click)="validateMultupleLeadsNeeded();" class="btn btn-secondary">Save</button> -->
	</div>
</ng-template>
<!-- End needed Multiple-->
<ng-template #neededAll let-modal="let-modal" let-d="dismiss">
	<div class="modal-header">
		<h3 class="modal-title" id="modal-basic-title">How Many Leads Needed? New API</h3>
	</div>
	<div class="modal-body">
		<form>
			<div class="form-group">
				<input [(ngModel)]="leads_needed" name="leads_needed" type="text" class="form-control" placeholder="Enter the new number of leads needed." (focus)="focus = true" />
			</div>
		</form>
	</div>
	<div class="modal-footer p-3">
		<button type="button" (click)="d()" class="btn btn-danger">Cancel</button>
		<button type="button" (click)="validateLeadsNeeded(); d()" class="btn btn-secondary">Save</button>
	</div>
</ng-template>
<!-- Reserve -->
<ng-template #reserveModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">Reserve · {{ reserveCampaign?.name }}</h5>
		<button type="button" class="btn-close" (click)="modal.dismiss()"></button>
	</div>

	<div class="modal-body">
		<app-loader *ngIf="reserveLoading"></app-loader>

		<ng-container *ngIf="!reserveLoading">
			<div class="row text-center mb-3">
				<div class="col-4">
					<small class="text-muted d-block">Deposits</small>
					<strong>{{ (reserveSummary?.total_deposits || 0) | currency }}</strong>
				</div>
				<div class="col-4">
					<small class="text-muted d-block">Applied</small>
					<strong>{{ (reserveSummary?.total_applied || 0) | currency }}</strong>
				</div>
				<div class="col-4">
					<small class="text-muted d-block">Balance</small>
					<strong [class.text-danger]="(reserveSummary?.balance || 0) <= 0">{{ (reserveSummary?.balance || 0) | currency }}</strong>
				</div>
			</div>

			<div class="d-flex gap-2 mb-3">
				<input type="number" min="0" step="0.01" class="form-control" placeholder="Deposit amount" [(ngModel)]="reserveAmount" name="reserveAmount" />
				<button type="button" class="btn btn-success text-nowrap" [disabled]="reserveSaving" (click)="addReserveDeposit()">
					<span *ngIf="reserveSaving" class="spinner-border spinner-border-sm me-1"></span>
					Add deposit
				</button>
			</div>

			<div class="table-responsive">
				<table class="table table-sm align-middle mb-0">
					<thead>
						<tr>
							<th>Date</th>
							<th>Type</th>
							<th class="text-end">Amount</th>
							<th>Lead</th>
							<th>Registered by</th>
							<th>Status</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let m of reserveMovements" [class.text-muted]="m.status === 'canceled'">
							<td>{{ m.created_at | date: 'MMM d, y h:mm a' }}</td>
							<td class="text-capitalize">{{ m.movement_type }}</td>
							<td class="text-end">{{ m.amount | currency }}</td>
							<td>{{ m.lead_id || '-' }}</td>
							<td>{{ m.created_by_name }}</td>
							<td class="text-capitalize">{{ m.status }}</td>
							<td class="text-end">
								<button *ngIf="m.movement_type === 'income' && m.status === 'active'" type="button" class="btn btn-sm btn-light text-danger" ngbTooltip="Cancel deposit" (click)="cancelReserveDeposit(m)">
									<i class="ri-close-circle-line"></i>
								</button>
							</td>
						</tr>
						<tr *ngIf="reserveMovements.length === 0">
							<td colspan="7" class="text-center text-muted py-3">No movements yet.</td>
						</tr>
					</tbody>
				</table>
			</div>
		</ng-container>
	</div>

	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modal.close()">Close</button>
	</div>
</ng-template>
<!-- End Reserve -->

<div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
	<div>
		<h4 class="mb-1">Campaigns</h4>
		<small class="text-muted"> {{ active }} active campaigns · Pending reschedules: {{ reschedule }} </small>
	</div>

	<div class="d-flex flex-wrap gap-2">
		<button type="button" class="btn btn-success btn-label waves-effect waves-light rounded-pill" (click)="addCampaign()">
			<i class="ri-add-circle-fill label-icon align-middle rounded-pill fs-16 me-2"></i>
			Add Campaign
		</button>

		<button type="button" class="btn btn-success btn-label waves-effect waves-light rounded-pill" data-bs-toggle="modal" data-bs-target="#content" (click)="openModal(content)">
			<i class="ri-refresh-fill label-icon align-middle rounded-pill fs-16 me-2"></i>
			Set Multiple Needed
		</button>

		<button type="button" class="btn btn-success btn-label waves-effect waves-light rounded-pill" (click)="resetNeededConfirmAll()">
			<i class="ri-refresh-fill label-icon align-middle rounded-pill fs-16 me-2"></i>
			Reset All Needed
		</button>

		<button type="button" class="btn btn-success btn-label waves-effect waves-light rounded-pill" (click)="resetHopperConfirmAll()">
			<i class="ri-recycle-fill label-icon align-middle rounded-pill fs-16 me-2"></i>
			Recycle All
		</button>
	</div>
</div>

<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-body">
				<app-loader *ngIf="campaignsLoading"></app-loader>

				<div *ngIf="!campaignsLoading" class="col-md-12 ml-auto mr-auto">
					<div class="campaign-toggle">
						<button type="button" class="toggle-option" [class.active]="campaignTab === 'active'" (click)="toggleCampaignList('active')">Active ({{ active }})</button>

						<button type="button" class="toggle-option" [class.active]="campaignTab === 'inactive'" (click)="toggleCampaignList('inactive')">Inactive ({{ inactive }})</button>
					</div>
					<div class="ngxtable">
						<br />
						<div class="row">
							<div class="col-6" align="left">
								<input type="text" class="form-control" placeholder="Search" (keyup)="updateFilter2($event, 'name,alias')" />
							</div>
							<div class="col-6" align="right">
								<button (click)="exportToExcel()" type="button" class="btn btn-success btn-label waves-effect waves-light">
									<i class="ri-file-excel-fill label-icon align-middle fs-16 me-2"></i>
									Export
								</button>
							</div>
						</div>

						<div class="table-responsive">
							<table class="cc-table-campaigns">
								<thead>
									<tr>
										<th class="col-idx">#</th>
										<th class="col-switch">Active</th>
										<th class="campaign-name num sortable" (click)="sortBy('name')">
											Name
											<i class="ri-arrow-up-s-line" *ngIf="sortColumn === 'name' && sortDirection === 'asc'"></i>
											<i class="ri-arrow-down-s-line" *ngIf="sortColumn === 'name' && sortDirection === 'desc'"></i>
										</th>
										<th class="num sortable" (click)="sortBy('ordered')">
											Weekly ordered
											<i class="ri-arrow-up-s-line" *ngIf="sortColumn === 'ordered' && sortDirection === 'asc'"></i>
											<i class="ri-arrow-down-s-line" *ngIf="sortColumn === 'ordered' && sortDirection === 'desc'"></i>
										</th>
										<th class="num sortable" (click)="sortBy('lead_cost')">
											$/Lead
											<i class="ri-arrow-up-s-line" *ngIf="sortColumn === 'lead_cost' && sortDirection === 'asc'"></i>
											<i class="ri-arrow-down-s-line" *ngIf="sortColumn === 'lead_cost' && sortDirection === 'desc'"></i>
										</th>
										<th class="num sortable" (click)="sortBy('records')">
											Records
											<i class="ri-arrow-up-s-line" *ngIf="sortColumn === 'records' && sortDirection === 'asc'"></i>
											<i class="ri-arrow-down-s-line" *ngIf="sortColumn === 'records' && sortDirection === 'desc'"></i>
										</th>
										<th class="num sortable" (click)="sortBy('pending_reschedule')">
											Reschedules
											<i class="ri-arrow-up-s-line" *ngIf="sortColumn === 'pending_reschedule' && sortDirection === 'asc'"></i>
											<i class="ri-arrow-down-s-line" *ngIf="sortColumn === 'pending_reschedule' && sortDirection === 'desc'"></i>
										</th>
										<th class="num sortable" (click)="sortBy('timezone')">
											Timezone
											<i class="ri-arrow-up-s-line" *ngIf="sortColumn === 'timezone' && sortDirection === 'asc'"></i>
											<i class="ri-arrow-down-s-line" *ngIf="sortColumn === 'timezone' && sortDirection === 'desc'"></i>
										</th>
										<th class="num sortable" (click)="sortBy('leads_needed')">
											Needed
											<i class="ri-arrow-up-s-line" *ngIf="sortColumn === 'leads_needed' && sortDirection === 'asc'"></i>
											<i class="ri-arrow-down-s-line" *ngIf="sortColumn === 'leads_needed' && sortDirection === 'desc'"></i>
										</th>
										<th class="num sortable" (click)="sortBy('industry')">
											Industry
											<i class="ri-arrow-up-s-line" *ngIf="sortColumn === 'industry' && sortDirection === 'asc'"></i>
											<i class="ri-arrow-down-s-line" *ngIf="sortColumn === 'industry' && sortDirection === 'desc'"></i>
										</th>
										<th class="num">Types</th>
										<th class="num">Action</th>
									</tr>
								</thead>

								<tbody>
									<tr *ngFor="let row of campaigns; let i = index">
										<td class="col-idx">{{ i + 1 }}</td>

										<td class="col-switch">
											<div class="form-check form-switch" *ngIf="campaignTab === 'active'">
												<input class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" checked ngbTooltip="Deactivate Campaign" (click)="deactivateConfirm(row)" />
											</div>
											<div class="form-check form-switch" *ngIf="campaignTab === 'inactive'">
												<input class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" ngbTooltip="Activate Campaign" (click)="activateConfirm(row)" />
											</div>
										</td>

										<td class="background-gray campaign-name">
											<div class="d-flex flex-column" (dblclick)="editCampaign(row)" style="cursor: pointer; line-height: 1.3">
												<strong>{{ row.name }}</strong>
												<small class="text-muted">{{ row.alias }}</small>
											</div>
										</td>

										<td class="num">{{ row.ordered < 1 ? "-" : row.ordered }}</td>

										<td class="num">{{ row.lead_cost < 1 ? "-" : "$" + row.lead_cost }}</td>

										<td class="num">
											<span *ngIf="!campaignsMetadataLoading">{{ row.records < 1 ? "-" : row.records }}</span>
											<p class="placeholder-glow mb-0" *ngIf="campaignsMetadataLoading">
												<span class="placeholder col-12"></span>
											</p>
										</td>

										<td class="num">
											<span *ngIf="!campaignsMetadataLoading">{{ row.pending_reschedule < 1 ? "-" : row.pending_reschedule }}</span>
											<p class="placeholder-glow mb-0" *ngIf="campaignsMetadataLoading">
												<span class="placeholder col-12"></span>
											</p>
										</td>

										<td class="num">{{ row.timezone }}</td>

										<td class="num background-gray">{{ row.leads_needed < 1 ? "-" : row.leads_needed }}</td>

										<td class="num">{{ getIndustryDescription(row.industry) }}</td>

										<td class="num" [innerHTML]="row.types"></td>

										<td class="num">
											<div align="center" ngbDropdown container="body">
												<button type="button" class="btn btn-light btn-icon border-0 shadow-none no-caret" ngbDropdownToggle>
													<i class="ri-more-fill fs-18"></i>
												</button>
												<div ngbDropdownMenu>
													<button ngbDropdownItem class="text-primary" (click)="downloadRecords(row)"><i class="ri-download-2-line me-2"></i> Download List</button>
													<button ngbDropdownItem class="text-warning" (click)="openCalendar(row.id, row.alias)"><i class="ri-calendar-line me-2"></i> Calendar</button>
													<button ngbDropdownItem class="text-success" (click)="recycleRecordsToCampaign(row)"><i class="ri-recycle-line me-2"></i> Recycle Records</button>
													<button ngbDropdownItem class="text-danger" (click)="deleteProspectsFromCampaign(row)"><i class="ri-delete-bin-line me-2"></i> Unassign all records</button>
													<button ngbDropdownItem class="text-success" (click)="openNeeded(needed, row)"><i class="ri-refresh-line me-2"></i> Leads Needed</button>
													<button ngbDropdownItem class="text-info" *ngIf="row.campaign_type === 'R'" (click)="openReserve(reserveModal, row)"><i class="ri-money-dollar-circle-line me-2"></i> Reserve</button>
												</div>
											</div>
										</td>
									</tr>

									<tr *ngIf="campaigns.length === 0">
										<td colspan="10" class="text-center py-4 text-muted">No campaigns found.</td>
									</tr>
								</tbody>

								<tfoot>
									<tr *ngIf="campaignTab === 'active'">
										<td colspan="10">
											<div class="row" style="width: 100%">
												<div class="col-4"><strong class="title-header">Pending Reschedules: </strong>{{ footerTotals.activeReschedule }}</div>
												<div class="col-4"><strong class="title-header">Total Score: </strong>{{ footerTotals.activeScore.toFixed(2) }}</div>
												<div class="col-4"><strong class="title-header">Leads Needed: </strong>{{ footerTotals.activeNeeded }}</div>
											</div>
										</td>
									</tr>
									<tr *ngIf="campaignTab === 'inactive'">
										<td colspan="10">
											<div class="row" style="width: 100%">
												<div class="col-4"><strong class="title-header">Pending Reschedules: </strong>{{ footerTotals.inactiveReschedule }}</div>
												<div class="col-4"><strong class="title-header">Total Score: </strong>{{ footerTotals.inactiveScore }}</div>
												<div class="col-4"><strong class="title-header">Leads Needed: </strong>{{ footerTotals.inactiveNeeded }}</div>
											</div>
										</td>
									</tr>
								</tfoot>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
